"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.livaNovaFonts = exports.epsyFonts = void 0;
exports.epsyFonts = {
    fontFamily: "Gilroy"
};
exports.livaNovaFonts = {
    fontFamily: "Lato"
};
